import { useQuery } from "react-query"
import { useGqlClient } from "../client"
import { useAuth } from "./useAuth"
import { activeProjects } from '../queries/projects'

type ActiveProject = {
 id: string
 name: string
}

export const useActiveProjectsQuery = (options?: any) => {
  const gqlClient = useGqlClient()
  const { token } = useAuth()
  return useQuery(
    'activeProjects', 
    async () => {
      const data = await gqlClient.request<{ active_projects: ActiveProject[] }>(activeProjects)

      return data?.active_projects || []
    },
    { enabled: !!token, staleTime: Infinity, ...options },
    )
  }